export default __webpack_public_path__ + "static/media/gallery_03.db697dc8.jpg";